"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var PlayerMultiaccountsListCtl = /** @class */ (function (_super) {
    __extends(PlayerMultiaccountsListCtl, _super);
    function PlayerMultiaccountsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.login; });
        _this.dk_email = UIUtils_1.UIUtils.IProp2Str(function (o) { o.email; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_deposits_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposits_count; });
        _this.dk_withdraws_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraws_count; });
        _this.dk_deposits_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposits_amount; });
        _this.dk_withdraws_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraws_amount; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_partner_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_login; });
        _this.dk_custom_zone_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.custom_zone_title; });
        _this.dk_time_zone_offset_hours = UIUtils_1.UIUtils.IProp2Str(function (o) { o.time_zone_offset_hours; });
        _this.dk_password = UIUtils_1.UIUtils.IProp2Str(function (o) { o.password; });
        _this.dk_by_ip_city = UIUtils_1.UIUtils.IProp2Str(function (o) { o.by_ip_city; });
        _this.dk_by_ip_country_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.by_ip_country_code; });
        _this.dk_by_ip_organisation = UIUtils_1.UIUtils.IProp2Str(function (o) { o.by_ip_organisation; });
        _this._errDialog = errDialog;
        return _this;
    }
    PlayerMultiaccountsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    PlayerMultiaccountsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "player with id [" + id + "] not found !";
    };
    PlayerMultiaccountsListCtl.prototype.LoadAllDataByIp = function (playerId, onDone) {
        var _this = this;
        webAApi_1.ListMultiAccountPlayersByIpAddrByPlayerIdGet.exec({ user_player_id: playerId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    login: resp.list[i].login,
                    email: resp.list[i].email,
                    is_locked: resp.list[i].is_locked,
                    deposits_count: resp.list[i].deposits_count,
                    withdraws_count: resp.list[i].withdraw_count,
                    deposits_amount: resp.list[i].deposits_amount,
                    withdraws_amount: resp.list[i].withdraw_amount,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    partner_login: resp.list[i].partner_login,
                    custom_zone_title: resp.list[i].custom_zone_title,
                    time_zone_offset_hours: resp.list[i].time_zone_offset_hours,
                    password: resp.list[i].password,
                    by_ip_city: resp.list[i].by_ip_city,
                    by_ip_country_code: resp.list[i].by_ip_country_code,
                    by_ip_organisation: resp.list[i].by_ip_organisation
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerMultiaccountsListCtl.prototype.LoadAllDataByPassword = function (playerId, onDone) {
        var _this = this;
        webAApi_1.ListMultiAccountPlayersByPasswordByPlayerIdGet.exec({ user_player_id: playerId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    login: resp.list[i].login,
                    email: resp.list[i].email,
                    is_locked: resp.list[i].is_locked,
                    deposits_count: resp.list[i].deposits_count,
                    withdraws_count: resp.list[i].withdraw_count,
                    deposits_amount: resp.list[i].deposits_amount,
                    withdraws_amount: resp.list[i].withdraw_amount,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    partner_login: resp.list[i].partner_login,
                    custom_zone_title: resp.list[i].custom_zone_title,
                    time_zone_offset_hours: resp.list[i].time_zone_offset_hours,
                    password: resp.list[i].password,
                    by_ip_city: resp.list[i].by_ip_city,
                    by_ip_country_code: resp.list[i].by_ip_country_code,
                    by_ip_organisation: resp.list[i].by_ip_organisation
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerMultiaccountsListCtl.prototype.SetPlayerIsLocked = function (key, IsLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPlayerIsLocked.exec({
                player_id: key,
                is_locked: IsLocked
            }, function (resp) {
                _tmp.is_locked = IsLocked;
                // _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return PlayerMultiaccountsListCtl;
}(BaseController_1.BaseController));
exports.PlayerMultiaccountsListCtl = PlayerMultiaccountsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ctl/PlayerMultiaccountsListCtl.ts
// module id = 1037
// module chunks = 0